import React, { useEffect, useState } from 'react';
import { useFreehand } from '@/lib/freehandStore';

const clampDim = (v) => Math.max(0.1, Math.min(100, v));

// Keeps the typed text locally so the field can be cleared; commits valid numbers.
const DimField = ({ label, value, onCommit, testId }) => {
  const [text, setText] = useState(String(value));
  useEffect(() => { setText(String(value)); }, [value]);
  const commit = (t) => { const v = Number(t); if (t !== '' && v > 0) onCommit(clampDim(v)); };
  return (
    <label className="flex-1 flex items-center gap-1.5 text-[11px] text-slate-500">
      {label}
      <input
        type="number"
        min={0.1}
        step={0.5}
        value={text}
        onChange={(e) => { setText(e.target.value); commit(e.target.value); }}
        onBlur={() => setText(String(value))}
        data-testid={testId}
        className="w-full h-7 rounded-md border border-slate-200 px-1.5 text-xs text-slate-900 focus:outline-none focus:border-slate-900"
      />
    </label>
  );
};

export const RectangleSizeInputs = () => {
  const w = useFreehand((s) => s.rectW);
  const h = useFreehand((s) => s.rectH);
  const setRectSize = useFreehand((s) => s.setRectSize);
  return (
    <div className="space-y-1" data-testid="freehand-rect-size">
      <div className="flex gap-2">
        <DimField label="W" value={w} onCommit={(v) => setRectSize(v, h)} testId="freehand-rect-width" />
        <DimField label="H" value={h} onCommit={(v) => setRectSize(w, v)} testId="freehand-rect-height" />
      </div>
      <div className="text-[10px] text-slate-400">Proportion {(w / h).toFixed(2)} : 1 — drag on the ball sets the overall size.</div>
    </div>
  );
};
